export { default } from "./AnimatedMobileMenuItem";
